import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTank = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 95.38,
	viewBox: "0 0 40.0 95.38",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 40.0 7.69 L 40.0 87.69 A 13.0 5.0 0.0 0 1 0.0 87.69 L 0.0 7.69 A 13.0 5.0 0.0 0 1 40.0 7.69 Z M 0.0 7.69 L 40.0 7.69 M 0.0 87.69 L 40.0 87.69",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgTank;
